import { Spinner, Text } from '@cad-arc';
import { PREFILLED_WITH_UNIT_GPS_LOCATION_MESSAGE } from './constants';

export function FrEventLocationAutomaticGpsPrefillContent({
    isLoading,
    isPrefilledWithUnitGpsLocation,
}: {
    isLoading: boolean;
    isPrefilledWithUnitGpsLocation: boolean;
}) {
    if (isLoading) {
        return <Spinner size="sm" />;
    }

    if (isPrefilledWithUnitGpsLocation) {
        return (
            <Text isItalic fontSize="md">
                {PREFILLED_WITH_UNIT_GPS_LOCATION_MESSAGE}
            </Text>
        );
    }

    return (
        <Text isItalic fontSize="md" color="negative">
            Location could not be prefilled. Enter your location manually.
        </Text>
    );
}
